<template>
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.2613 42.3203C28.8678 42.3203 29.301 42.784 29.301 43.3319L29.301 45.9873C29.301 46.5774 28.8245 46.9989 28.2613 46.9989C27.6549 46.9989 27.2217 46.5353 27.2217 45.9873L27.2217 43.3319C27.2217 42.784 27.6982 42.3203 28.2613 42.3203Z"
      fill="#5A6698"
    />
    <path
      d="M22.0671 40.5099C22.2836 40.2991 22.5436 40.2148 22.8035 40.2148C23.0634 40.2148 23.3666 40.2991 23.5399 40.5099C23.9731 40.9314 23.9731 41.5636 23.5399 41.9851L21.5905 43.8819C21.1574 44.3034 20.5076 44.3034 20.0744 43.8819C19.6412 43.4604 19.6412 42.8281 20.0744 42.4066L22.0671 40.5099Z"
      fill="#5A6698"
    />
    <path
      d="M17.735 34.9453L20.464 34.9453C21.0705 34.9453 21.5037 35.409 21.5037 35.9569C21.5037 36.5048 21.0272 36.9685 20.464 36.9685L17.735 36.9685C17.1285 36.9685 16.6953 36.5048 16.6953 35.9569C16.6953 35.409 17.1718 34.9453 17.735 34.9453Z"
      fill="#5A6698"
    />
    <path
      d="M34.8027 35.7889C34.8027 35.1988 35.2792 34.7773 35.8424 34.7773L38.5714 34.7773C39.1779 34.7773 39.6111 35.241 39.6111 35.7889C39.6111 36.3369 39.1346 36.8005 38.5714 36.8005L35.8424 36.8005C35.2792 36.8005 34.8027 36.3369 34.8027 35.7889Z"
      fill="#5A6698"
    />
    <path
      d="M33.6764 40.0469C33.9363 40.0469 34.2395 40.1312 34.4128 40.3419L36.3621 42.2387C36.7953 42.6602 36.7953 43.2924 36.3621 43.7139C35.929 44.1354 35.2792 44.1354 34.846 43.7139L32.8967 41.8172C32.4635 41.3957 32.4635 40.7634 32.8967 40.3419C33.1133 40.1733 33.4165 40.0469 33.6764 40.0469Z"
      fill="#5A6698"
    />
    <path
      d="M41.4855 15.1348C41.4855 14.0606 40.8857 13.1173 39.9819 12.5805C40.8857 12.0438 41.4855 11.1005 41.4855 10.0263C41.4855 9.11752 41.0557 8.30286 40.3763 7.74775C40.0662 7.46394 39.6599 7.24851 39.1616 7.12352C38.8711 7.04338 38.5641 7 38.2461 7C38.2264 7 38.2067 7.00073 38.187 7.00147C38.154 7.00147 38.1217 7 38.0886 7L27.5515 7C22.4817 7 17.7599 9.56602 15.5603 10.5321L15.4863 25.8959C17.7864 27 23.3057 29.5 25.3184 37.2933C25.8576 39.3814 27.5604 40.3762 29.297 39.9696C30.9904 39.5733 31.4635 38.2712 31.2864 36C30.84 30.2709 28.6938 26.1187 28.175 25.4651C27.6711 24.8298 29.8085 25.2687 31.5239 27.712L38.2461 27.712C40.0355 27.712 41.4863 26.3569 41.4863 24.6857C41.4863 23.7975 41.0754 22.9998 40.4236 22.4461C41.077 21.8925 41.4863 21.0933 41.4863 20.2051C41.4863 19.1441 40.9006 18.2103 40.0158 17.6707C40.9014 17.1303 41.4863 16.1972 41.4863 15.1363L41.4855 15.1348Z"
      fill="url(#paint0_linear_5576_143379)"
    />
    <rect
      x="6.28613"
      y="9"
      width="10"
      height="19"
      rx="1"
      fill="url(#paint1_linear_5576_143379)"
    />
    <path
      d="M13.2861 13C13.2861 14.1134 12.3995 15 11.2861 15C10.1727 15 9.28613 14.1134 9.28613 13C9.28613 11.8866 10.1727 11 11.2861 11C12.3995 11 13.2861 11.8866 13.2861 13Z"
      fill="#EEEEFF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5576_143379"
        x1="17.8355"
        y1="4.31605"
        x2="46.9072"
        y2="47.3852"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ACACD1" />
        <stop offset="1" stop-color="#5A6698" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5576_143379"
        x1="11.2861"
        y1="9"
        x2="11.5464"
        y2="29.1326"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5A6698" />
        <stop offset="1" stop-color="#21355E" />
      </linearGradient>
    </defs>
  </svg>
</template>
